import { SponsorModel, PartnerModel } from "../models";
import { BoundsShape } from "../models/QueryModel";

export default abstract class SponsorRepository {
  abstract get(bounds: BoundsShape): Promise<{
    sponsors: SponsorModel[];
    regionalPartners: PartnerModel[];
  }>;
}
